// contains a bunch of global functions, possibly these should be put into an object
window.toggle_inline = function(dom_item) {
  const toggle_base_id = dom_item.data('toggle');
  const suffixes = ['_display', '_edit'];

  suffixes.forEach(suffix => {
    $(`${toggle_base_id}${suffix}`).toggle();
  });

  return false;
};

window.reset_form = function(form_id) {
  return $(form_id)[0].reset();
};

window.capitalize = function(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

window.show_errors = function(errors) {
  const messages = Object.entries(errors).map(([field, messages]) => {
    const friendly_field = field.split('_')
      .map(piece => capitalize(piece))
      .join(' ');

    const friendly_messages = messages
      .map(msg => capitalize(msg))
      .join('\n');

    return `${friendly_field}: ${friendly_messages}`;
  });

  alert(messages.join('\n'));
};